export default __webpack_public_path__ + "static/media/Psyche_Icon_Color-PNG.1aaadcf0.png";